<div class="container-md" >
  <div
    class="d-flex justify-content-end mt-2"
    *ngIf="authService.userLogged?.idProfile == 1 || (authService.userLogged?.idEntity == selectedAuction().idEntitySeller && (selectedAuction().statusDescription == 'IDS_STATUS_CREATING' || selectedAuction().statusDescription == 'IDS_STATUS_REVISIONING'))"
  >
    <button
      (click)="onEdit(selectedAuction().idAuction)"
      class="admin-edit-delete-button"
    >
      <fa-icon [icon]="faEdit" size="2x"></fa-icon>
    </button>
  </div>
  <div class="grid-article mt-3 mb-3">
    <div class="img-slideshow-gallery1">
      <app-article-gallery
        *ngIf="isLoaded()"
        [selectedAuction]="selectedAuction()"
      ></app-article-gallery>
    </div>

    <div class="article-properties" *ngIf="isLoaded()">
      <div
        class="h-full"
        [class.article-properties-gold]="isMemorabid() && !inPreEventStatus"
        [class.article-properties-marketplace]="!isMemorabid() && !inPreEventStatus"
        [class.article-properties-preEvent]="inPreEventStatus"
      >
        <app-article-properties
          [sportIds]="sportIds()"
          [competitionIds]="competitionIds()"
          [teamIds]="teamIds()"
          [selectedAuction]="selectedAuction()"
          [inPreEventStatus]="inPreEventStatus"
          [isPreEventFinished]="isPreEventFinished"
        ></app-article-properties>
        <app-article-bid
          [selectedAuction]="selectedAuction()"
          [sportIds]="sportIds()"
          [competitionIds]="competitionIds()"
          [teamIds]="teamIds()"
          [minimumOffer]="minimumOffer()"
          [inPreEventStatus]="inPreEventStatus"
          [isPreEventFinished]="isPreEventFinished"
          (getHistory)="getHistory()"
          (onSuccessBid)="reloadAuctionOnBidSuccess($event)"
          (deleteAutoRebid)="deleteAutoRebid($event)"
          (stopRefresh)="stopRefresh()"
          class="sticky-article-bid"
        ></app-article-bid>
      </div>
    </div>
    <div class="article-description">
      <app-article-description
        *ngIf="isLoaded()"
        [selectedAuction]="selectedAuction()"
      ></app-article-description>
    </div>
    <div>
      <app-tags
        *ngIf="isLoaded()"
        [selectedAuction]="selectedAuction()"
        [inPreEventStatus]="inPreEventStatus"
      ></app-tags>
    </div>
    <div
      class="contacts"
      [class.contacts-gold]="isMemorabid() && !inPreEventStatus"
      [class.contacts-marketplace]="!isMemorabid() && !inPreEventStatus"
      [class.contacts-preEvent]="inPreEventStatus"
    >
      <p class="text-contact">
        <b>{{'IDS_NEED_HELP' | translate}}</b><br />
        {{'IDS_NEED_HELP_CONTACT' | translate}}<br />
        <i>{{'IDS_NEED_HELP_TEAM' | translate}}</i>
      </p>
      <button
        class="text-uppercase text-small admin-new"
        [class.preEvent]="inPreEventStatus"
        (click)="contact()"
      >
        {{'IDS_NEED_HELP_SEND' | translate}}
      </button>
    </div>
  </div>
</div>
@defer {
  <app-suggested-auctions
    *ngIf="memorabidAuctionSuggestions.length > 0"
    [auctionSuggestions]="memorabidAuctionSuggestions"
    [isMemorabid]="true"
  >
  </app-suggested-auctions>
  <app-suggested-auctions
    *ngIf="marketplaceAuctionSuggestions.length > 0"
    [auctionSuggestions]="marketplaceAuctionSuggestions"
    [isMemorabid]="false"
  >
  </app-suggested-auctions>
}
